'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _treatAdminList = require('./treat-admin-list.component');

var _treatAdminList2 = _interopRequireDefault(_treatAdminList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.treatAdminList', []).component('treatAdminList', _treatAdminList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/treat-admin-list/treat-admin-list.module.js